<template>
  <div class="group-bar">
    <span class="group-bar__label">
      <v-icon size="14">mdi-account-group</v-icon>
      Groups
    </span>
    <GroupControl
      :assigned-groups="assignedGroups"
      :entity-type="entityType"
      :entity-id="entityId"
      size="md"
      @update:assigned-groups="$emit('update:assignedGroups', $event)" />
  </div>
</template>

<script setup>
import GroupControl from "@/components/dashboard/GroupControl.vue";

defineProps({
  assignedGroups: { type: Array, default: () => [] },
  entityType: { type: String, required: true },
  entityId: { type: [String, Number], required: true },
});

defineEmits(["update:assignedGroups"]);
</script>

<style lang="scss" scoped>
.group-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 6px 2px 14px;
}

.group-bar__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: $lh_font_family_dm_sans;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: $lh_color_blue_gray;
  white-space: nowrap;
}
</style>
